import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { EntityItemContainer } from 'components/Global/EntityItem/styled.js';
import { ContentCardContainer } from 'components/Global/Card/styled.js';
import { contentCentered } from 'helpers/styles.js';

export const SearchTitle = styled.div`
  font-weight: bold;
  font-size: 10px;
  line-height: 14px;
  letter-spacing: 1.5px;
  color: ${({ theme }) => theme.colors.palette[5]};
  margin-bottom: 32px;
  margin-left: 8px;

  span {
    background: ${({ theme }) => theme.colors.palette[5]};
    color: white;
    border-radius: 6px;
    font-weight: 500;
    font-size: 10px;
    padding: 5px 4px 5px 5px;
    text-align: center;
    margin-left: 5px;
    height: 20px;
    display: inline-block;
  }
`;

export const SearchResultsHeightContainer = styled.div`
  position: absolute;
  height: 100%;
`;

export const PreviewContainer = styled.div`
  position: fixed;
  top: 70px;
  left: 54px;
  overflow: hidden;
  bottom: 0;
  right: 0;
  height: auto;
  background: ${({ theme }) => theme.colors.palette[0]};
`;

export const PreviewCol = styled.div`
  display: inline-block;
  width: 33%;
  padding: 0 ${({ theme }) => theme.padding.medium};
  vertical-align: top;
  height: 240px;
  margin-bottom: 20px;

  ${EntityItemContainer} {
    display: inline-block;
    margin-bottom: 24px;
    width: 100%;
  }

  /* Shows the perfect scroll bar always instead of hover only */
  .ps > .ps__scrollbar-y-rail {
    opacity: 1;
  }
`;

export const ContentPreviewContainer = styled.div`
  margin: ${({ splitView }) => splitView ? '48px 1%' : '48px auto'};
  display: inline-block;
  vertical-align: top;
  width: ${({ splitView }) => splitView ? '48%' : '100%'};

  ${ContentCardContainer} {
    width: ${({ theme, splitView }) => splitView ? theme.cardWidths.half : theme.cardWidths.third};
    height: 355px;

    @media (min-width: 1100px) {
      width: ${({ theme, splitView }) => splitView ? theme.cardWidths.half : theme.cardWidths.third};
      height: 360px;
    }

    @media (min-width: 1300px) {
      width: ${({ theme, splitView }) => splitView ? theme.cardWidths.half : theme.cardWidths.fourth};
      height: 370px;
    }
  }
`;

export const CenterContainer = styled.div`
  height: 100%;
  ${contentCentered}
`;

export const StyledViewAllButton = styled(Link)`
  display: inline-block;
  cursor: pointer;
  text-transform: uppercase;
  letter-spacing: 2px;
  padding: 8px 14px;
  margin: 4px 8px 4px 15px;
  border-radius: 20px;
  position: relative;
  line-height: 13px;
  height: 28px;
  font-size: 9px;
  border: ${({ theme }) => `1px solid ${theme.colors.palette[5]}}`};
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  color: #fff;
  background-color: transparent;

  &:hover {
    background-color: ${({ theme }) => theme.colors.palette[5]}
  }
`;

export const PreviewScrollContainer = styled.div`
  position: relative;
`;

export const ResultsContainer = styled.div`
  position: relative;
  opacity: ${({ shown }) => shown ? 1 : 0};
  transition: all 0.3s ease;
`;
